import React from "react";
import { Modal } from "react-bootstrap";
import useTranslator from "../../hooks/useTranslator";
import "./AwardInsuranceProcessingModal.css";

const AwardInsuranceProcessingModal = ({ show }) => {
  const { _t } = useTranslator();
  const titleKey = "processingYourRequest";
  const descriptionKey = "thisUsuallyTakesAFewSecondsPleaseDontCloseThisWindow";

  return (
    <Modal
      show={show}
      onHide={() => {}}
      backdrop="static"
      keyboard={false}
      centered
      className="award-processing-modal"
      aria-labelledby="award-processing-title"
      aria-describedby="award-processing-description"
    >
      <Modal.Body>
        <div className="award-processing-content" aria-live="polite">
          <div className="award-processing-spinner" aria-hidden="true" />
          <h2 id="award-processing-title">{_t(titleKey)}</h2>
          <p id="award-processing-description">{_t(descriptionKey)}</p>
          <div className="award-processing-dots" aria-hidden="true">
            <span />
            <span />
            <span />
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default AwardInsuranceProcessingModal;
